var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 7.0835H7.08333",
    stroke: "#0B3B60",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7569 7.7915H12.9135C11.6496 7.7915 10.625 8.74287 10.625 9.9165C10.625 11.0901 11.6496 12.0415 12.9135 12.0415H14.7569C14.816 12.0415 14.8455 12.0415 14.8704 12.04C15.2524 12.0167 15.5566 11.7342 15.5817 11.3795C15.5833 11.3563 15.5833 11.3289 15.5833 11.2742V8.55884C15.5833 8.50409 15.5833 8.47667 15.5817 8.45351C15.5566 8.09878 15.2524 7.8163 14.8704 7.79299C14.8455 7.7915 14.816 7.7915 14.7569 7.7915Z",
    stroke: "#0B3B60"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8502 7.79167C14.7952 6.46545 14.6176 5.65232 14.0451 5.07986C13.2153 4.25 11.8796 4.25 9.20835 4.25H7.08335C4.41206 4.25 3.07642 4.25 2.24655 5.07986C1.41669 5.90973 1.41669 7.2454 1.41669 9.91667C1.41669 12.5879 1.41669 13.9236 2.24655 14.7535C3.07642 15.5833 4.41206 15.5833 7.08335 15.5833H9.20835C11.8796 15.5833 13.2153 15.5833 14.0451 14.7535C14.6176 14.181 14.7952 13.3679 14.8502 12.0417",
    stroke: "#0B3B60"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.25 4.25L6.89597 2.49555C7.64108 2.00148 8.65059 2.00148 9.39569 2.49555L12.0417 4.25",
    stroke: "#0B3B60",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7438 9.9165H12.7506",
    stroke: "#0B3B60",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.74e12c791c140a2bb341419a57974517.svg";
export { ForwardRef as ReactComponent };